/**
 * Dark mode preference: load from localStorage on first paint, fall back
 * to `prefers-color-scheme: dark`, apply via `data-theme="dark"|"light"`
 * attribute on `<html>`.
 */

export type Theme = 'light' | 'dark';

const STORAGE_KEY = 'maplens.theme.v1';

export function loadTheme(): Theme {
  if (typeof window === 'undefined') return 'light';
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored === 'light' || stored === 'dark') return stored;
  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return 'dark';
  }
  return 'light';
}

export function saveTheme(theme: Theme): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // QuotaExceeded — preference simply doesn't persist.
  }
}

export function applyTheme(theme: Theme): void {
  if (typeof document === 'undefined') return;
  document.documentElement.dataset['theme'] = theme;
  // Update theme-color so the browser chrome on mobile matches the palette.
  const color = theme === 'dark' ? '#1a1410' : '#f5f0e1';
  let meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (meta === null) {
    meta = document.createElement('meta');
    meta.name = 'theme-color';
    document.head.appendChild(meta);
  }
  meta.content = color;
}
